import moment from 'moment-timezone';
import { FORMAT_DATE } from '../../constants/common';
import { QuestionSchedulePayload } from '../../repository/mytm/home/cartnerConvosRepository';

export const toDataFormScheduleTiles = (record: QuestionSchedulePayload): any => {
  return {
    startDate: record?.activeAt ? moment(moment(record?.activeAt).format(FORMAT_DATE)) : null,
    startTime: record?.activeAt ? moment(record?.activeAt) : null,
    endDate: record?.inActiveAt ? moment(moment(record?.inActiveAt).format(FORMAT_DATE)) : null,
    endTime: record?.inActiveAt ? moment(record?.inActiveAt) : null,
  };
};
